import { render, staticRenderFns } from "./SemicircleIcon.vue?vue&type=template&id=3b261849"
import script from "./SemicircleIcon.vue?vue&type=script&lang=js"
export * from "./SemicircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports